require('../controllers/legacy-page-ctrl.js');
angular.element(function() {
    angular.bootstrap(document, ['appMarketplace']);
});


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/page-entries/legacy-page-entry.js
// module id = 498
// module chunks = 35